import './App.css';
import Games from './pages/Games';
import Home from './pages/Home';
import Categories from './pages/Categories';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { useEffect, useState } from 'react';
import Preloader from './components/Preloader';
import { AnimatePresence } from 'framer-motion';

const Layout = () => {
  return (
    <>
    <Navbar />
    <Outlet />
    <Footer />
    </>
  )
}


const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Home />
      },
      {
        path: '/games',
        element: <Games />
      },
      {
        path: '/Categories',
        element: <Categories />
      },
    ]
  },
  {
    path: '/games',
    element: <Games />
  },
  {
    path: '/Categories',
    element: <Categories />
  },
]);

function App() {

  const [isLoading, setIsLoading] = useState(true);
  useEffect( () => {
    (
      async () => {
          const LocomotiveScroll = (await import('locomotive-scroll')).default
          const locomotiveScroll = new LocomotiveScroll();

          setTimeout( () => {
            setIsLoading(false);
            document.body.style.cursor = 'default'
            window.scrollTo(0,0);
          }, 2000)
      }
    )()
  }, []);

  return (
    <div className="App">
      <div className='container'>
        <AnimatePresence mode='wait'>
          {
            isLoading && <Preloader />
          }
        </AnimatePresence>
        <RouterProvider router={router}/>
      </div>
    </div>
  );
}

export default App;
